import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import classNames from 'classnames';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import AddEditUsersTabs from '../addEditUser/addEditUsersTabs';
import { UserEditFormMode } from '../../../services/enums/users';
import DeleteDialog from '../../portal/dialogs/deleteDialog';
import ResetPasswordByManagerDialog from '../../account/resetPasswordByManager/resetPasswordByManagerDialog';
import ExcemptUserFromMFADialog from '../../account/twoFA/excemptUserFromMFADialog';
import AccessToUiDialog from '../../account/accessToUiDialog';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import AuthenticationProviderType from '../../../services/enums/authenticationProviderType';
import formatAuthenticationProvider from '../../../services/formatters/authenticationProviderFormatter';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import styles from './style.scss';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'usersStore', 'addEditUserStore', 'oidcStore', 'authenticationProvidersStore') @observer
export default class UserGridContextMenu extends Component {

    state = {
        openContextMenu: false,
        openDeleteDialog: false,
        openResetPassword: false,
        openErrorDialog: false,
        showEditUserModal: false,
        showDuplicateUserModal: false,
        openMFAExemption: false,
		openAccessToUi: false
    };

    t = this.props.translationsStore;

    openEditMenu = (event) => {

        event.preventDefault();

        this.setState({
            openContextMenu: true,
            anchorEl: event.currentTarget
        });
    };

    handleRequestClose = () => this.setState({openContextMenu: false});

    closeAll = () => {
        this.setState({ 
            openDeleteDialog: false,
            openContextMenu: false,
            openResetPassword: false,
            openMFAExemption: false,
			openAccessToUi: false
        }); 
    }

    openEditUserModal = (e) => {

        this.props.usersStore.getUser(this.props.userId).then((user) =>
        {
            this.props.authenticationProvidersStore.getAllAuthenticationProviders().then((providers) => {
                const addEditUserStore = this.props.addEditUserStore;

                let provider = providers.filter(p => p.id == user.authenticationProviderId)[0];
                addEditUserStore.setAuthenticationProviderType(provider.providerType);
                addEditUserStore.setAuthenticationProviderFormatted(formatAuthenticationProvider(provider));

                addEditUserStore.setUserId(user.id);
                addEditUserStore.setFirstName(user.firstName);
                addEditUserStore.setLastName(user.lastName);
                addEditUserStore.setUserName(user.userName);
                addEditUserStore.setEmail(user.email);
                addEditUserStore.setJobTitle(user.jobTitle || '');

                addEditUserStore.setPhoneNumber(user.phoneNumber || '');
                addEditUserStore.setCellPhoneNumber(user.cellPhoneNumber || '');
                addEditUserStore.setOther(user.other || '');
                addEditUserStore.setCountry(user.country || '');

                addEditUserStore.setActive(user.active);
                addEditUserStore.setExpirationDate(user.expirationDate);

                addEditUserStore.setLocaleId(user.localeId);
                addEditUserStore.setRoleIds(user.roleIds);
                addEditUserStore.setTeamIds(user.teamIds);
                addEditUserStore.setAuthenticationProviderId(user.authenticationProviderId);
                addEditUserStore.setTenant(user.tenant);
                addEditUserStore.setTwoFAExemption(user.twoFAExemption);
                addEditUserStore.setAccessToUi(user.accessToUi);
                addEditUserStore.setFormMode(UserEditFormMode.edit);

                this.closeAll();
                this.setState({ 
                    showEditUserModal: true
                });
            });
        });
    }

    openDuplicateUserModal = (e) => {

        this.props.usersStore.getUser(this.props.userId).then((user) =>
        {
            this.props.authenticationProvidersStore.getAllAuthenticationProviders().then((providers) => {
                
                const addEditUserStore = this.props.addEditUserStore;

                let provider = providers.filter(p => p.id == user.authenticationProviderId)[0];
                addEditUserStore.setAuthenticationProviderType(provider.providerType);
                addEditUserStore.setAuthenticationProviderFormatted(formatAuthenticationProvider(provider));

                addEditUserStore.setActive(true);

                addEditUserStore.setLocaleId(user.localeId);
                addEditUserStore.setRoleIds(user.roleIds);
                addEditUserStore.setTeamIds(user.teamIds);
                addEditUserStore.setAuthenticationProviderId(user.authenticationProviderId);
                addEditUserStore.setTenant(user.tenant);

                addEditUserStore.setFormMode(UserEditFormMode.add);

                this.closeAll();
                this.setState({ 
                    showDuplicateUserModal: true
                });
            });
        });
    }

    closeUserModal = (e) => {

        this.props.addEditUserStore.formMode == UserEditFormMode.edit ?
            this.setState({ showEditUserModal: false}) : this.setState({showDuplicateUserModal: false});

        const applicationProvider = this.props.authenticationProvidersStore.getApplicationAuthenticationProvider();     

        this.props.addEditUserStore.setAuthenticationProviderId(applicationProvider.id);
        this.props.addEditUserStore.setDefaultAuthenticationProviderType();
        this.props.addEditUserStore.reset();
    }

    openDeleteDialog = () => {
        this.closeAll();
        this.setState({ 
            openDeleteDialog: true
        }); 
    }

    openResetPasswordDialog = () => {
        this.closeAll();
        this.setState({
            openResetPassword: true
        });
    }

    openMFAExemptionDialog = () => {
        this.closeAll();
        this.setState({
            openMFAExemption: true
        });
    }
    
	openAccessToUiDialog = () => {
        this.closeAll();
        this.setState({
            openAccessToUi: true
        });
    }    
    closeDeleteDialog = () => this.setState({openDeleteDialog: false}); 

    openErrorDialog = () => this.setState({openErrorDialog: true}); 

    closeErrorDialog = () => this.setState({openErrorDialog: false }); 

    closeResetPasswordDialog = () => this.setState({openResetPassword: false}); 

    closeMFAExemptionDialog = () => {
        this.setState({ openMFAExemption: false });
    };

    closeAccessToUiDialog = () => {
        this.setState({ openAccessToUi: false });
    };
	
    handleDeleteDialogConfirm = () => {

        this.props.usersStore.deleteUser(this.props.userId).then(() => {

            this.props.usersStore.getAllUsers();
            this.closeDeleteDialog();
            
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.t.translate('USER_DELETED_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({level, message});
        })
        .catch(() => {

            this.closeDeleteDialog();
            this.openErrorDialog();

        });
    }

    handleSuccessfulEditUserOperation(message) {

        this.props.usersStore.getAllUsers();

        this.closeUserModal();

        var level = ToastrLevelsEnum.SUCCESS;
        var message = this.t.translate(message);
        ToastrService.triggerToastr({level, message});

        this.props.addEditUserStore.reset();       
    }
    

    handleSubmitForm = (e) => {

        e.preventDefault();

        this.props.addEditUserStore.setAddUserErrorMessage('');
        
        const isValid = this.props.addEditUserStore.validateEditForm();

        if (isValid === false) {

            this.props.addEditUserStore.setIsAddUserError(true);
            const validationErrorMessage = this.props.translationsStore.translate('SEE_ERRORS_BELOW');
            this.props.addEditUserStore.setAddUserErrorMessage(validationErrorMessage);
            return;
        }
        
        this.props.addEditUserStore.formMode == UserEditFormMode.edit ?
            this.props.addEditUserStore.updateUser().then(() => this.handleSuccessfulEditUserOperation('USER_UPDATED_SUCCESS_MESSAGE')): 
            this.props.addEditUserStore.createUser().then(() => this.handleSuccessfulEditUserOperation('USER_CREATED_SUCCESS_MESSAGE'));
    }

    render() {
       let isEditMode = this.props.addEditUserStore.formMode == UserEditFormMode.edit;

        const translationsStore = this.props.translationsStore;

        const actions = <div className='user-form-buttons-container'>
                            <span className='portal-blank-button' 
                                onClick={this.closeUserModal}   
                                data-cy='cancel-user-button'>
                                {this.props.translationsStore.translate('CANCEL')}
                            </span>
                            <Button
                                type='submit'
                                dataCy='save-user-button'
                                onClick={this.handleSubmitForm}
                                inProgress={this.props.addEditUserStore.creatingUser || this.props.addEditUserStore.updatingUser}
                                text={this.props.translationsStore.translate('SAVE')}>
                            </Button>
                        </div>;
        
        const dialog = <Dialog 
                            className={classNames(styles.ldapAddGroupsHeader)}
                            actions={actions}
                            open={isEditMode ? this.state.showEditUserModal :this.state.showDuplicateUserModal}
                            repositionOnUpdate={false}
                            actionsContainerStyle={{padding: 0}}
                        >
                            <div className={classNames(styles.dialogMainWrapper)}>
                                <div className={classNames(styles.dialogMainHeaderWrapper)} data-cy='edit-duplicate-user-form'>
                                    <DialogHeader
                                        title={isEditMode ? this.props.translationsStore.translate('EDIT_USER') : this.props.translationsStore.translate('ADD_NEW_USER')}
                                        closeClick={this.closeUserModal}
                                        displayCloseButton
                                    />
                                </div>
                                <div>
                                    <form>
                                        <AddEditUsersTabs />
                                    </form>
                                </div>
                            </div>
                        </Dialog>;
        return (
            <div className='context-menu-button'>
                <RaisedButton
                    onClick={this.openEditMenu}
                    className='grid-context-menu-button' data-cy='edit-user-menu-icon-button'
                    buttonStyle={{
                        width: '16px'
                    }}
                    icon={<span className='menu-icon icon-button'></span>} />
                <Popover
                    className='edit-context-menu'
                    style={{
                        fontSize: '15px'
                    }}
                    open={this.state.openContextMenu} 
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    onRequestClose={this.handleRequestClose}>
                    <Menu>
                        <MenuItem  
                            onClick={this.openEditUserModal} primaryText={translationsStore.translate('EDIT_USER')}
                            data-cy='edit-user-action'
                        />
                        <MenuItem  
                            onClick={this.openDuplicateUserModal} primaryText={translationsStore.translate('DUPLICATE_USER')}
                            data-cy='duplicate-user-action'
                        />
                        <MenuItem disabled={this.props.userId == this.props.oidcStore.currentUser.profile.sub}
                            onClick={this.openDeleteDialog} primaryText={translationsStore.translate('DELETE_USER')} />
                        <MenuItem onClick={this.openResetPasswordDialog} primaryText={translationsStore.translate('RESET_PASSWORD')}
                            disabled={this.props.authenticationProviderType.toLowerCase() !== AuthenticationProviderType.Application.toLowerCase()} />
                        <MenuItem onClick={this.openMFAExemptionDialog} disabled={this.props.authenticationProviderType.toLowerCase() !== AuthenticationProviderType.Application.toLowerCase()}
                            primaryText={this.props.twoFAExemption ? translationsStore.translate('DISABLE_EXCEMPT_2FA') : translationsStore.translate('ENABLE_EXCEMPT_2FA')} />
							
                        <MenuItem onClick={this.openAccessToUiDialog} disabled={this.props.userId == this.props.oidcStore.currentUser.profile.sub || this.props.authenticationProviderType.toLowerCase() !== AuthenticationProviderType.Application.toLowerCase()}
                            primaryText={this.props.accessToUi ? translationsStore.translate('ACCESS_TO_UI_DISABLE') : translationsStore.translate('ACCESS_TO_UI_ENABLE')} />
                    </Menu>
                </Popover>
                {dialog}
                <DeleteDialog 
                    show={this.state.openDeleteDialog}
                    onConfirm={this.handleDeleteDialogConfirm}
                    closeDeleteDialog={this.closeDeleteDialog}
                    titleText={this.props.translationsStore.translate('DELETE_USER') + '?'}
                    contentText={this.props.translationsStore.translate('DELETE_USER_CONFIRM').replace('{userName}', this.props.userName)} 
                    inProgress={this.props.usersStore.deletingUser}
                    deleteButtonText={this.props.translationsStore.translate('DELETE')}                                
                    cancelText={this.props.translationsStore.translate('CANCEL')}/>
                <ResetPasswordByManagerDialog 
                    userId={this.props.userId}
                    userName={this.props.userName}
                    show={this.state.openResetPassword}
                    onClose={this.closeResetPasswordDialog} />
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.props.usersStore.deletingUserErrorMessage} />
                <ExcemptUserFromMFADialog
                    userId={this.props.userId}
                    userName={this.props.userName}
                    show={this.state.openMFAExemption}
                    enableExemption={!this.props.twoFAExemption}
                    onClose={this.closeMFAExemptionDialog}
                    titleText={this.props.twoFAExemption ? this.props.translationsStore.translate('REMOVE_EXCEMPT_MFA_MODAL_TITLE') : this.props.translationsStore.translate('EXCEMPT_MFA_MODAL_TITLE')}
                    buttonText={this.props.twoFAExemption ? this.props.translationsStore.translate('DISABLE_Exemption_MODAL_BUTTON') : this.props.translationsStore.translate('ENABLE_Exemption_MFA_MODAL_BUTTON')}
                    dialogText={this.props.twoFAExemption ? this.props.translationsStore.translateWithArguments('REMOVE_EXCEMPT_MFA_MODAL_CONTENT_Q', [this.props.userName]) : this.props.translationsStore.translateWithArguments('EXCEMPT_MFA_MODAL_CONTENT_Q', [this.props.userName])}
                    />              
                <AccessToUiDialog
                    userId={this.props.userId}
                    userName={this.props.userName}
                    show={this.state.openAccessToUi}
                    enableAccessToUi={!this.props.accessToUi}
                    onClose={this.closeAccessToUiDialog}
                    titleText={this.props.accessToUi ? this.props.translationsStore.translate('ACCESS_TO_UI_DISABLE') : this.props.translationsStore.translate('ACCESS_TO_UI_ENABLE')}
                    buttonText={translationsStore.translate('CONTINUE')}
                    dialogText={this.props.accessToUi ? this.props.translationsStore.translateWithArguments('ACCESS_TO_UI_BLOCK_MESSAGE_Q', [this.props.userName]) : this.props.translationsStore.translateWithArguments('ACCESS_TO_UI_UNBLOCK_MESSAGE_Q', [this.props.userName])}
                    />              
            </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/components/users/userGridContextMenu/index.jsx